import { REQUEST_DOCUMENTS_ENTITY } from '../../../constants/entity'
import { FILE_SCOPE_REQUEST } from '../../../constants/file'
import { getDocumentsMassActions } from '../../Document'
import { EntityTabDocuments } from '../../EntityTab'
import { ButtonSelect } from '../../Select'
import { REQUEST_PROFILE_TAB_DOCUMENTS } from '../RequestProfile.constants'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import {
  QA_NAME_REQUEST_PROFILE_TAB_DOCUMENTS,
  REQUEST_PROFILE_TAB_DOCUMENTS_BREADCRUMB_REQUEST,
} from './RequestProfileTabDocuments.constants'
import {
  useRequestProfileTabDocumentsSendViaEmail,
  useRequestProfileTabDocumentsUpload,
} from './RequestProfileTabDocuments.hooks'
import {
  getRequestProfileTabDocumentsItemActions,
  getRequestProfileTabDocumentsRootBreadcrumbs,
} from './RequestProfileTabDocuments.utils'

import * as styles from './RequestProfileTabDocuments.module.css'

function RequestProfileTabDocuments({ onLoadCounters }) {
  const {
    isPreview,
    outboundUuid,
    registerDocumentsTabReload,
    relatedRequestsCount,
    requestData,
  } = useRequestProfileContext()

  const breadcrumbRootItems = getRequestProfileTabDocumentsRootBreadcrumbs({
    requestData,
  })

  const { handleAfterUpload, renderUploadDestinationModal, uploadButtonProps } =
    useRequestProfileTabDocumentsUpload({
      className: styles.uploadBtn,
      relatedRequestsCount,
      requestData,
    })

  const contextData = { outboundUuid, relatedRequestsCount, requestData }

  const { handleSendViaEmail } = useRequestProfileTabDocumentsSendViaEmail()

  async function handleLoadDocumentsCounters() {
    return onLoadCounters?.([REQUEST_PROFILE_TAB_DOCUMENTS])
  }

  return (
    <EntityTabDocuments
      UploadButton={ButtonSelect}
      breadcrumbRootItems={breadcrumbRootItems}
      breadcrumbStorageItemId={REQUEST_PROFILE_TAB_DOCUMENTS_BREADCRUMB_REQUEST}
      className={styles.RequestProfileTabDocuments}
      contextData={contextData}
      entity={REQUEST_DOCUMENTS_ENTITY}
      getItemActions={getRequestProfileTabDocumentsItemActions}
      getMassActions={getDocumentsMassActions}
      isPreview={isPreview}
      objectId={requestData?.id}
      outboundUuid={outboundUuid}
      qaNameTable={QA_NAME_REQUEST_PROFILE_TAB_DOCUMENTS}
      renderUploadDestinationModal={renderUploadDestinationModal}
      rootDirectoryId={requestData?.directory_id}
      scope={FILE_SCOPE_REQUEST}
      uploadButtonProps={uploadButtonProps}
      onAfterUpload={handleAfterUpload}
      onLoadCounters={handleLoadDocumentsCounters}
      onRegisterReload={registerDocumentsTabReload}
      onSendViaEmail={handleSendViaEmail}
    />
  )
}

export default RequestProfileTabDocuments
